import { contactDeleteDescription as description } from './description';
import { deleteContact as execute } from './execute';

export { description, execute };
